module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Manage Account</h1>\n    </header>\n\n    <div class="manage-account-composite-region" />\n</div>\n<footer class="default-footer"></footer>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/manageAccount/ManageAccountSettingsView.tpl
// module id = 3107
// module chunks = 0